module.exports = __webpack_public_path__ + "img/extended.41437e32.png";